import { render, staticRenderFns } from "./CardPropertyObjectCustom.vue?vue&type=template&id=3d22fad6&scoped=true&"
import script from "./CardPropertyObjectCustom.vue?vue&type=script&lang=js&"
export * from "./CardPropertyObjectCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22fad6",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel,QBtn,QTooltip}, component.options.components || {})
